import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';

const TextFieldSC = styled(TextField)(({ theme }) => ({
  '.MuiFormLabel-root.mui-focused': {
    color: '#2685CA !important'
  },
  '.MuiFormLabel-root': {
    paddingLeft: '8px',
    fontFamily: 'Segoe UI',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '120%',
    color: '#8F8F8F',
  },
  '.MuiInputBase-root':{
    fontFamily: 'Segoe UI',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '120%',
  },
  '.MuiInput-root:before':{
    borderBottom: '1px solid #E5E5E5'
  },
  'label.MuiFormLabel-root .MuiInputLabel-asterisk':{
    color: '#DC2626'
  }
}));
export default TextFieldSC
